import { render } from "./MyTitle.vue?vue&type=template&id=32319953&scoped=true"
import script from "./MyTitle.vue?vue&type=script&lang=js"
export * from "./MyTitle.vue?vue&type=script&lang=js"

import "./MyTitle.vue?vue&type=style&index=0&id=32319953&scoped=true&lang=css"

import exportComponent from "/home/hadams/code/Vuejs_Wordle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32319953"]])

export default __exports__